/**
 * Created by andrey on 03.08.17.
 */

const Level = function (episodeNo, levelNo, options) {
    options = options || {};

    if (arguments.length === 0) {
        return;
    }

    this.episodeNo = episodeNo;
    this.levelNo = levelNo;

    const bundle = bundles[this.bundleId()];
    this.meta = bundle.meta.episode ? ({ ...bundle.meta.episode.levels && bundle.meta.episode.levels[levelNo] || {} }) : bundle.meta;

    this.levelType = options.type ? options.type : Level.CalcLevelType(episodeNo);
};

Level.prototype.bundleId = function () {
    return Level.BundleId(this.episodeNo);
};

Level.prototype.getHumanReadableNumber = function () {
    return cleverapps.humanReadableNumber(this.episodeNo, this.levelNo);
};

Level.prototype.isRegular = function () {
    return this.levelType === Level.LevelTypes.REGULAR;
};

Level.prototype.isDailyCup = function () {
    return this.levelType === Level.LevelTypes.DAILYCUP;
};

Level.prototype.isBonusRound = function () {
    return this.levelType === Level.LevelTypes.BONUSROUNDS;
};

Level.prototype.isBonusWorldLevel = function () {
    return this.levelType === Level.LevelTypes.BONUS_WORLD;
};

Level.prototype.isAdsLevel = function () {
    return this.levelType === Level.LevelTypes.ADS || this.levelType === Level.LevelTypes.PROMO || this.levelType === Level.LevelTypes.SCREENSHOTS;
};

Level.prototype.isWeeklyTournamentLevel = function () {
    return this.levelType === Level.LevelTypes.WEEKLY_TOURNAMENT;
};

Level.prototype.getTag = function () {
    return this.meta.tag;
};

Level.prototype.isHard = function () {
    return Level.IsHardTag(this.getTag());
};

Level.prototype.isSuperHard = function () {
    return this.getTag() === Level.TAGS.SUPERHARD;
};

Level.prototype.getRewardTag = function () {
    return this.isSuperHard() ? Level.TAGS.HARD : this.getTag();
};

Level.prototype.setMissionTag = function (missionTag) {
    this.missionTag = missionTag;
};

Level.prototype.getMissionTag = function () {
    return this.missionTag;
};

Level.prototype.isTricky = function () {
    return this.getTag() === Level.TAGS.TRICKY;
};

Level.prototype.isDanger = function () {
    return this.isTricky() && cleverapps.config.features.includes("danger");
};

Level.prototype.isBonus = function () {
    return this.getTag() === Level.TAGS.BONUS;
};

Level.prototype.getImageBundle = function () {
    return this.meta.bundleName;
};

Level.prototype.setupContent = function () {
    let levelData;

    if (this.meta.location) {
        levelData = cc.loader.getRes(bundles[this.bundleId()].jsons.map_json);
    } else {
        const levels = cc.loader.getRes(bundles[this.bundleId()].jsons.levels);
        levelData = Array.isArray(levels) ? levels[this.levelNo] : levels.levels[this.levelNo];
    }

    if (Array.isArray(levelData)) {
        let maxVersion = 0;

        levelData.forEach((level, index) => {
            let version = level.version || index;
            version = parseInt(version);

            if (version > maxVersion || !this.content) {
                maxVersion = version;

                this.content = level;
            }
        });
    } else {
        this.content = levelData;
    }

    this.hash = Level.CalcHash(this.content);
    this.version = this.content.version;
};

Level.prototype.play = function (f, options) {
    const mainLocationId = cleverapps.meta.getMainLocationId();
    if (cleverapps.playButton && cleverapps.meta.selectedLocationId() !== mainLocationId) {
        cleverapps.playButton.playedFromLocationId = cleverapps.meta.selectedLocationId();
        cleverapps.meta.switchLocation(mainLocationId);
    }

    const shouldSkipVictoryWindow = typeof Game !== "undefined" && Game.currentGame && Game.currentGame.shouldSkipVictoryWindow();

    if (cleverapps.config.editorMode) {
        cleverapps.config.editorMode = false;
        this.content = undefined;
        cleverapps.environment.setScene(cleverapps.Environment.SCENE_GAME);
    }

    const sceneOptions = {
        styling: shouldSkipVictoryWindow && cleverapps.Scenes.GetRunningScene().sceneComponent.styling,
        level: this,
        gameOptions: options
    };

    const scene = typeof GameScene === "function"
        ? new GameScene(sceneOptions)
        : Prefab.instantiate(GameScene, { args: [sceneOptions] });

    cleverapps.scenes.replaceScene(scene, f);
};

Level.prototype.onPressed = function () {
    cleverapps.focusManager.display({
        focus: "LevelPressedPlay",
        action: function (f) {
            Level.WantsToPlay(f, {
                level: this
            });
        }.bind(this)
    });
};

Level.prototype.getStartWindowOptions = function () {
    const options = {};

    if (this.isDanger()) {
        options.danger = true;
    } else if (cleverapps.config.features.includes("boosters_before") && WindowBoostersBefore.isAvailable()) {
        options.boostersBefore = true;

        if (typeof Lantern !== "undefined" && Lantern.IsActive(this) && cleverapps.config.features.includes("lantern_start")) {
            options.lantern = true;
        }
    }

    options.level = this;

    return options;
};

Level.prototype.clone = function () {
    const level = new Level();
    Object.assign(level, this);
    return level;
};

Level.BundleId = function (episodeNo) {
    let name = (["merge", "merge2"].includes(cleverapps.config.type) ? "location_" : "episode_") + episodeNo; // needs for background styles

    if (cleverapps.config.type === "board" && cleverapps.settings.language !== "en") {
        name += `_${cleverapps.settings.language}`;
    }

    return name;
};

Level.CreateByNumber = function (x, options) {
    options = options || {};

    let episodeNo = Math.floor(x / Level.LEVELS_PER_EPISODE);
    let levelNo = x % Level.LEVELS_PER_EPISODE;

    const total = levels.User.CalcEpisodesAmount(cleverapps.config.importMode);
    if (episodeNo >= total) {
        episodeNo = total;
        levelNo = 0;
        const seed = x - cleverapps.humanReadableNumber(episodeNo, levelNo) + 1;

        return levels.user.getRandomLevel({ seed, type: options.type });
    }

    return new Level(episodeNo, levelNo, options);
};

Level.ListTagged = function (firstEpisodeNo, lastEpisodeNo, tag) {
    const numbers = [];

    for (let episodeNo = firstEpisodeNo; episodeNo < lastEpisodeNo; episodeNo++) {
        const episode = bundles[Level.BundleId(episodeNo)].meta.episode;
        const metas = episode && episode.levels || [];

        metas.forEach((meta, levelNo) => {
            if (meta.tag === tag) {
                numbers.push(episodeNo * Level.LEVELS_PER_EPISODE + levelNo);
            }
        });
    }

    return numbers;
};

Level.CalcHash = function (levelContent) {
    return RecursiveHasher(levelContent, ["episodeNo", "levelNo", "version", "hard", "paint", "extra", "gold", "hash", "hashes", "comments", "translate", "definitions", "bundles", "horizontalCards"]);
};

Level.CalcLevelType = function (episodeNo) {
    if (typeof BonusWorld !== "undefined" && BonusWorld.getConfigByEpisode(episodeNo)) {
        return Level.LevelTypes.BONUS_WORLD;
    }

    if (Level.LevelTypeValues[episodeNo]) {
        return episodeNo;
    }

    return Level.LevelTypes.REGULAR;
};

Level.IsEnoughLives = function (level) {
    if (level.type === Level.LevelTypes.DAILYCUP && !cleverapps.dailyCup.withLives()) {
        return true;
    }

    const lives = typeof LivesHelper !== "undefined" ? LivesHelper.GetMainInstance() : cleverapps.lives;
    return !(lives && lives.isEmpty());
};

Level.OpenLivesShop = function () {
    const lives = typeof LivesHelper !== "undefined" ? LivesHelper.GetMainInstance() : cleverapps.lives;
    if (lives && lives.isWithEnergy()) {
        new EnergyShopWindow();
    } else {
        new LivesShopWindow();
    }
};

Level.WantsToPlay = function (f, options = {}) {
    const location = cleverapps.meta.getSelectedLocation();
    let level = options.level;
    if (location.getWantsToPlayFarmLevel) {
        level = location.getWantsToPlayFarmLevel(level);
    } else {
        level = level || Level.GetCurrentLevel();
    }

    const wantsToShowStartWindow = LevelStartWindow.isAvailable(level) && (!cleverapps.config.features.includes("boosters_before") || WindowBoostersBefore.isAvailable());

    if (!Level.IsEnoughLives(level)) {
        if (cleverapps.unlimitedLives && cleverapps.unlimitedLives.freeOfferIsAvailable()) {
            cleverapps.unlimitedLives.showFreeOffer(f);
        } else {
            Level.OpenLivesShop();
            cleverapps.focusManager.onceNoWindowsListener = f;
        }

        return;
    }

    new ActionPlayer([
        (f) => {
            if (options.interstitial !== false) {
                cleverapps.rewardedAdsManager.showInterstitial({
                    limit: AdsLimits.TYPES.INTERSTITIAL,
                    placement: AdsLimits.TYPES.INTERSTITIAL_PLAY
                }, f);
            } else {
                f();
            }
        },

        (f) => {
            if (cleverapps.knockoutGame && level.isRegular()) {
                cleverapps.knockoutGame.wantsToPlay(f);
            } else {
                f();
            }
        },

        (f) => {
            if (level.episodeNo >= levels.user.getEpisodesAmount()) {
                f();
                return;
            }

            if (wantsToShowStartWindow) {
                cleverapps.focusManager.showControlsWhileFocused("MenuBarGoldItem");

                if (level.building) {
                    new BuildingStartWindow({
                        building: level.building,
                        level
                    });
                } else {
                    new LevelStartWindow(level.getStartWindowOptions());
                }
                cleverapps.focusManager.onceNoWindowsListener = f;
            } else {
                level.play(f);
            }
        }
    ]).play(f);
};

Level.GetCurrentLevel = function (building) {
    const location = cleverapps.meta.getSelectedLocation();
    if (location.getCurrentFarmLevel) {
        return location.getCurrentFarmLevel(building);
    }

    if (cleverapps.isKnockoutGame()) {
        return cleverapps.knockoutGame.getNextLevel();
    }

    return cleverapps.user.getCurrentLevel();
};

Level.LevelTypes = {
    REGULAR: "regular",
    BONUSROUNDS: "bonusrounds",
    EDITOR: "editor",
    DAILYCUP: "dailycup",
    HIGHSCORE_MODE: "score_mode",
    BONUS_WORLD: "bonus_world",
    ADS: "ads",
    PROMO: "promo",
    SCREENSHOTS: "screenshots",
    PLAYABLE_ADS: "playable_ads",
    WEEKLY_TOURNAMENT: "weekly_tournament"
};

Level.LevelTypeValues = cleverapps.createSet(Object.values(Level.LevelTypes));

Level.LEVELS_PER_EPISODE = 15;

Level.TYPE_PASSED = 0;
Level.TYPE_CURRENT = 1;
Level.TYPE_NOTPASSED = 2;

Level.TAGS = {};
Level.TAGS.HARD = "hard";
Level.TAGS.SUPERHARD = "superhard";
Level.TAGS.TRICKY = "tricky";
Level.TAGS.BONUS = "bonus";
Level.TAGS.RULES = "rules";

Level.IsHardTag = function (tag) {
    return tag === Level.TAGS.HARD || tag === Level.TAGS.SUPERHARD;
};

if (typeof cc === "undefined") {
    module.exports = Level;
}
